export default "__VITE_ASSET__YSubNTn$__"